import { motion } from "framer-motion";

export default function MentionsLegalesPage() {
  return (
    <div>
      <section className="relative py-24 overflow-hidden" data-testid="mentions-hero">
        <div className="absolute inset-0 bg-[#2C1E14]" />
        <div className="relative container-hh">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <h1 className="font-display text-4xl md:text-5xl text-white mb-4">Mentions légales</h1>
            <p className="text-white/70 text-lg">Informations légales relatives au site Happyhouse conciergerie.</p>
          </motion.div>
        </div>
      </section>

      <section className="section-hh bg-[#F5F0EB]" data-testid="mentions-content">
        <div className="container-hh max-w-3xl">
          <div className="bg-[#FFFDF9] p-8 md:p-12 rounded-xl shadow-[0_4px_24px_rgba(44,30,20,0.08)] border border-[#E0D6CA] space-y-8">
            <div>
              <h2 className="font-display text-xl text-[#004333] mb-3">Éditeur du site</h2>
              <p className="text-[#6B5E50] leading-relaxed">
                Happyhouse conciergerie<br />
                Société de conciergerie et gestion locative courte durée<br />
                Siège social : Limoges, France<br />
                Email : contact@happyhouse-conciergerie.fr<br />
                Téléphone : +33 7 67 48 43 13
              </p>
            </div>

            <div>
              <h2 className="font-display text-xl text-[#004333] mb-3">Hébergement</h2>
              <p className="text-[#6B5E50] leading-relaxed">
                Ce site est hébergé par un prestataire professionnel garantissant la sécurité et la disponibilité des données.
              </p>
            </div>

            <div>
              <h2 className="font-display text-xl text-[#004333] mb-3">Propriété intellectuelle</h2>
              <p className="text-[#6B5E50] leading-relaxed">
                L'ensemble des contenus présents sur ce site (textes, images, logos, graphismes) est protégé par le droit de la propriété intellectuelle. Toute reproduction, représentation ou diffusion, totale ou partielle, est interdite sans autorisation préalable de Happyhouse conciergerie.
              </p>
            </div>

            <div>
              <h2 className="font-display text-xl text-[#004333] mb-3">Responsabilité</h2>
              <p className="text-[#6B5E50] leading-relaxed">
                Happyhouse conciergerie s'efforce de fournir des informations exactes et à jour sur ce site. Toutefois, nous ne pouvons garantir l'exhaustivité ou l'exactitude des informations diffusées. Happyhouse conciergerie décline toute responsabilité pour tout dommage résultant de l'utilisation de ce site.
              </p>
            </div>

            <div>
              <h2 className="font-display text-xl text-[#004333] mb-3">Crédits photographiques</h2>
              <p className="text-[#6B5E50] leading-relaxed">
                Les photographies utilisées sur ce site proviennent de banques d'images libres de droits (Unsplash, Pexels) ou sont la propriété de Happyhouse conciergerie.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
